import { ICommitOrderOptions } from 'hooks/commit-order';
import { ICommitOrderMutationDeliveryInput } from 'remote/queries/order';
import { ServiceMode } from 'state/order';

export const buildCommitDeliveryInput = (
  order: ICommitOrderOptions['order'],
  enableSimpleDelivery = false
): ICommitOrderMutationDeliveryInput | null => {
  if (order.serviceMode !== ServiceMode.DELIVERY) {
    return null;
  }

  return {
    instructions: order.deliveryInstructions,
    tipCents: order.tipAmount,
    dropOff: enableSimpleDelivery ? order.deliveryAddress : undefined
  };
};
